<template>
  <div :id="customId"
       :class="{'loader-box-full-screen': full, 'hide-loader': full, 'middle': middle}"
       class="loader-box">
    <div class="la-line-scale-party line-scale-party">
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    full: {
      type: Boolean,
      default: false
    },
    middle: {
      type: Boolean,
      default: false
    },
    customId: {
      type: String,
      default: 'loader'
    }
  }
}
</script>

<style lang="scss">
@import './loader.sass';
</style>
